var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',{staticClass:"l-btn",class:{
		locked:!_vm.locked,
		disabled: _vm.disabled
	},attrs:{"icon":_vm.icon,"data-cy":"optional-btn"},on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }